import { auth, storage, createUser } from "@/firebase.js";

export async function upload_avatar_to_tmp(image) {
  const metadata = { contentType: image.type };
  const ref = storage.ref().child(`tmp/avatar/${+new Date()}-${image.name}`);
  await ref.put(image, metadata);
  return ref;
}

export const actions = {
  async create_user(context, { name, email, password, avatarImage }) {
    const ref = avatarImage && await upload_avatar_to_tmp(avatarImage);
    const response = await createUser({
      name,
      email,
      password,
      photoPath: ref?.fullPath
    });
    if (response.data.success) {
      await auth.signInWithEmailAndPassword(email, password);
    } else {
      throw new Error(response.data.errors);
    }
  },
  async logout({ dispatch }) {
    await dispatch("detatch_all_listeners", {}, { root: true });
    return await auth.signOut();
  }
};

export const mutations = {
  set_user(state, payload) {
    state.loggedIn = payload.loggedIn;
    state.uid = payload.uid;
    state.user = payload.user;
  }
};

export const getters = {
  loggedIn: state => state.loggedIn,
  auth: state => state.auth,
  user_id: state => state.uid,
  currentUser: state => state.user,
  user: (state, getters, rootState, rootGetters) => rootGetters["user/cached"]
};

export const state = () => ({
  auth,
  loggedIn: auth.currentUser === null ? undefined : true,
  uid: null,
  user: null
});

export default {
  state,
  getters,
  mutations,
  actions
};